<h1 [style.color]="color">
  {{ title }}
</h1>

<div [style.color]="color">
  {{ content }}
</div>

<ion-button strong (click)="change.emit(true)">
  {{ buttonLabel }}
</ion-button>
